import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AuthService } from "../../services/auth/auth.service";
import { OauthToken } from "../../models/oauth/oauth-token";
import { environment } from "../../../environments/environment";
import { take } from "rxjs";
import { selectOauthCodeVerifierValue, selectOauthStaterValue } from "../../stores/auth/auth.selector";
import { AuthOauthActions } from "../../stores/auth/auth.actions";
import { AppState } from "../../stores/app.state";
import { UserRouteTrackingService } from "../../services/user-route-tracking/user-route-tracking.service";

@Component({
  selector: 'app-login-callback',
  templateUrl: './login-callback.component.html',
  styleUrls: ['./login-callback.component.scss'],
  standalone: false
})
export class LoginCallbackComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private router: Router,
              private userRouteTrackingService: UserRouteTrackingService,
              private store: Store<AppState>) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe(params => {
      const code = params['code'];
      const f5State = params['state'];
      const currentState = this.store.selectSignal(selectOauthStaterValue)();

      //currently no state is returned from F5. only code.
      // if(f5State !== currentState) {
      //   console.error('state does not match')
      //   //TODO handle this error based on auth state?
      //   this.router.navigate(['error'], {
      //     state: { message: ClioConstants.CANT_COMPLETE_REQUEST }
      //   });
      //   return;
      // }

      if (!code) {
        // console.error("invalid code", code)
        //TODO handle this error based on auth state?
        this.router.navigate(['error/request-not-completed'], {
          queryParams: {
            code: 'LC-01'
          }
        });
        return;
      }

      const oauthCodeVerifier = this.store.selectSignal(selectOauthCodeVerifierValue)();
      // console.log({ oauthCodeVerifier });

      if (!oauthCodeVerifier) {
        // console.error("invalid code verifier", oauthCodeVerifier)
        //TODO handle this error based on auth state?
        this.router.navigate(['error/request-not-completed'], {
          queryParams: {
            code: 'LC-02'
          }
        });
        return;
      }

      this.handleCallback(code, oauthCodeVerifier);
      // this.store.select(selectOauthCodeVerifierValue).subscribe(codeVerifier => {
      //   this.handleCallback(code, codeVerifier);
      // })
    });
  }

  handleCallback(code: string, codeVerifier: string): void {
    const clientId = environment.oauth2ClientId;
    this.authService.exchangeCodeForToken(code, codeVerifier, clientId).subscribe({
      next: res => {
        // console.log(res)
        this.store.dispatch(AuthOauthActions.saveOauthToken({
          oauthAccessTokenValue: res.access_token,
          oauthRefreshTokenValue: res.refresh_token,
        }));
        const oauthToken: OauthToken = new OauthToken(res.access_token, res.refresh_token);
        if (!oauthToken.accessToken.clientNumber) { // if there are multiple surnames for the record, the token will not show the firstName field - but the user will still be able to log in to clipui
          this.router.navigate(['error/request-not-completed'], {
            queryParams: {
              code: 'LC-03'
            }
          });
        } else {
          const goPage = this.userRouteTrackingService.isLastPageAt();
          // console.log({ goPage });
          this.router.navigate([goPage]);
          // if (goPage.includes("email")) {
          //   console.log("include email. go to email")
          //   this.router.navigate(['/email'])
          // } else if (goPage.includes("cardstatus")) {
          //   console.log("include card status. go to card status")
          //   this.router.navigate(['/cardstatus'])
          // } else {
          //   console.log("else. go to email")
          //   this.router.navigate(['/email'])
          // }

          this.store.dispatch(AuthOauthActions.clearOauthCodeVerifier());
        }
      },
      error: err => {
        // console.log(err)
        this.router.navigate(['error/request-not-completed'], {
          queryParams: {
            code: 'LC-04'
          }
        });
      }
    })
  }
}
